export default {
    'configuration': true,
    'searchList': {
        'searchTxt': [
            {
                'name': '仓库',
                'value': 'whName',
                'unfold': true,
                'advanceConfig': [
                    { 'prop': 'cdwhName', 'value': '仓库名称' },
                    { 'prop': 'whCode', 'value': '仓库编码' }
                ],
                'tableConfig': [
                    { 'prop': 'whCode', 'value': '仓库编码' },
                    { 'prop': 'cdwhName', 'value': '仓库名称' }
                ],
                'advanceUrl': 'cdWarehouse/search?cdwhIsStop=0',
                'cbParams': ['whCode', 'cdwhName#whName'],
                'type': 'advance',
                'advanceCode': 'cdwhName',
                'span': 7
            },
            {
                'name': '库区',
                'value': 'zoneName',
                'type': 'input',
                'unfold': true,
                'span': 6
            },
            {
                'name': '波次号',
                'value': 'waveId',
                'type': 'input',
                'batch': true,
                'unfold': true,
                'span': 7
            }
        ],
        'unfoldState': false,
        'advancedBtn': false
    },
    table: {
        'clickModify': true,
        'selectBtn': true,
        'leftWidth': 160,
        'height': '400px',
        'leftOperation': false,
        'reserveSelection': true,
        'columns': [
            {
                'label': '运输单号',
                'prop': 'taskNo',
                'sort': true,
                'width': 170
            },
            {
                'label': '客户订单号',
                'prop': 'customerOrderNo',
                'sort': true,
                'width': 200
            },
            {
                'label': '套送订单号',
                'prop': 'tsOrderNo',
                'width': 160
            },
            {
                'label': '服务平台',
                'prop': 'siteName',
                'sort': true,
                'width': 110
            },
            {
                'label': '装货仓库',
                'prop': 'whName',
                'sort': true,
                'width': 120
            },
            {
                'label': '库区',
                'prop': 'zoneName',
                'sort': true,
                'width': 120
            },
            {
                'label': '客户',
                'prop': 'customerName',
                'sort': true,
                'width': 200
            },
            {
                'label': '发货地址',
                'prop': 'senderDetailAddr',
                'sort': true,
                'width': 200
            },
            {
                'label': '目的地址',
                'prop': 'receiverDetailAddr',
                'sort': true,
                'width': 200
            },
            {
                'label': '方量(m³)',
                'prop': 'totalVolume',
                'sort': true,
                'width': 100
            },
            {
                'label': '重量(Kg)',
                'prop': 'totalGrossWeight',
                'sort': true,
                'width': 100
            },
            {
                'label': '数量',
                'prop': 'totalQty',
                'sort': true,
                'width': 80
            },
            {
                'label': '时效产品',
                'prop': 'agingProductCode',
                'type': 'select',
                'optionNum': 'PRES_PRODUCT_CONFIG',
                'sort': true,
                'width': 120
            },
            {
                'label': '是否已预约',
                'prop': 'appointmentFlagName',
                'sort': true,
                'width': 110
            },
            {
                'label': '波次号',
                'prop': 'waveId',
                'sort': true,
                'width': 110
            }
        ]
    },
    'page': {
        'layout': 'total, sizes, prev, pager, next',
        'pageSize': 20,
        'pageSizes': [20, 50, 100]
    },
    // 高级搜索配置项
    'searchTotalTitle': []
};
